import { Button, CardContent, Collapse, Typography } from "@material-ui/core";
import React, { Component } from "react";
import { connect } from "react-redux";
import { compose } from "redux";
import { Field, formValueSelector, reduxForm } from "redux-form";
import * as actions from "../../actions";
import { updateTemplate } from "../../actions/EmailTemplate";
import CustomInputForm from "../../custom/CustomInput";
import CustomSelect from "../../custom/CustomSelect";
import { FormattedMessage } from "react-intl";

const reolveTemplateTypes = (templates) =>
  [...new Set(templates.map(({ type }) => type))].map((type) => ({
    input: <FormattedMessage id={`app.enuns.emailTemplate.${type}`} />,
    value: type,
  }));

class FormEmailTemplate extends Component {
  state = {
    previewOpen: false,
  };

  componentDidMount() {
    this.props.initialize(this.props.template);
  }

  onSubmit = (formProps) => {
    const { showSuccessMessage, showErrorMessage, onActionComplete } = this.props;

    updateTemplate(formProps.id, formProps)
      .then((response) => {
        showSuccessMessage("app.edit.sucesfully");
        onActionComplete();
      })
      .catch((e) => {
        showErrorMessage(e.response ? e.response.data.message : e);
      });
  };

  render() {
    const { handleSubmit, templates } = this.props;

    const types = reolveTemplateTypes(templates);

    const locales = [
      { input: <FormattedMessage id="app.language.en" />, value: "en" },
      { input: <FormattedMessage id="app.language.br" />, value: "br" },
      { input: <FormattedMessage id="app.language.es" />, value: "es" },
    ];
    return (
      <CardContent>
        <form onSubmit={handleSubmit(this.onSubmit)}>
          <Field
            name="subject"
            label="app.subject"
            InputLabelProps={{
              shrink: true,
            }}
            component={CustomInputForm}
            autoFocus
          />
          <Field
            name="sendgridTemplateId"
            label="app.email.sendgrid.templateId"
            InputLabelProps={{
              shrink: true,
            }}
            component={CustomInputForm}
          />
          <Field
            name="body"
            label="app.template"
            InputLabelProps={{
              shrink: true,
            }}
            multiline
            rows={15}
            component={CustomInputForm}
          />

          <Button
            color="primary"
            fullWidth
            onClick={() =>
              this.setState((state) => ({
                previewOpen: !state.previewOpen,
              }))
            }
            variant="contained"
          >
            {this.state.previewOpen ? <FormattedMessage id="app.email.hideBody" /> : <FormattedMessage id="app.email.previewBody" />}
          </Button>

          <Collapse in={this.state.previewOpen}>
            <div
              style={{
                overflow: "hidden",
              }}
            >
              <iframe
                title="email-body"
                srcDoc={this.props.body || ""}
                style={{
                  width: "100%",
                  marginTop: 16,
                  height: 450,
                  border: "1px solid #ddd5",
                  borderRadius: 4,
                }}
              />
            </div>
          </Collapse>

          <Field name="type" label="app.type" component={CustomSelect} values={types} />
          <Field name="locale" label="app.language" component={CustomSelect} values={locales} />
          <Typography gutterBottom>
            <strong>
              <FormattedMessage id="app.template.authWithdraw.variables" />
            </strong>
            $address, $date, $amount, $token, $frontUrl
          </Typography>
          <Typography gutterBottom>
            <strong>
              <FormattedMessage id="app.template.withdrawAuthorized.variables" />
            </strong>
            $address, $date, $amount, $name, $fee, $valueWithFee, $partnerWithdraw, $dueDate
          </Typography>
          <Typography gutterBottom>
            <strong>
              <FormattedMessage id="app.template.withdrawSended.variables" />
            </strong>
            $address, $date, $amount, $valueWithFee
          </Typography>
          <Typography gutterBottom>
            <strong>
              <FormattedMessage id="app.template.activateAccount.variables" />
            </strong>
            $token, $frontUrl, $name
          </Typography>
          <Typography gutterBottom>
            <strong>
              <FormattedMessage id="app.template.contract.variables" />
            </strong>
            $id, $name, $agentId, $agentName, $contractId, $amount, $deposit, $previsionAmount, $initial, $dueDate, $type, $phase, $maxMonthlyYield, $duration, $totalYield, $canceledBy
          </Typography>
          <Typography gutterBottom>
            <strong>
              <FormattedMessage id="app.template.payment.variables" />
            </strong>
            $name, $email, $paymentDate, $paymentsToday
          </Typography>
          <Button fullWidth id="bSubmitTypeForm" variant="contained" color="primary" type="submit" disabled={this.props.pristine || this.props.submitting || this.props.invalid}>
            <FormattedMessage id="app.button.save" />
          </Button>
        </form>
      </CardContent>
    );
  }
}

const validate = (values) => {
  const errors = {};
  
  if (!values.subject) {
    errors.subject = "app.subject.error";
  } else if (values.subject.trim().length === 0) {
    errors.subject = "app.subject.invalid";
  }

  const hasTemplateId = !!values?.sendgridTemplateId?.trim();
  const hasBody = !!values?.body?.trim();

  if (!hasTemplateId && !hasBody) {
    errors.body = "app.validation.emailTemplate.body.error";
    errors.sendgridTemplateId = "app.validation.emailTemplate.sendgridTemplateId.error";
  }

  if (!values.type) {
    errors.type = "app.type.error";
  }
  if (!values.locale) {
    errors.locale = "app.locale.error";
  }
  return errors;
};

const selector = formValueSelector("formEmailTemplate");

const mapStateToProps = (state) => ({
  body: selector(state, "body"),
});

export default compose(
  reduxForm({
    form: "formEmailTemplate",
    validate,
  }),
  connect(mapStateToProps, actions),
)(FormEmailTemplate);
